import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import { TESTIMONIALS } from "../data/content";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <SectionHeader
          center
          label="Testimonials"
          title="What our clients say"
          desc="Trusted by organizations who value quality, professionalism and efficiency."
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-7">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.title} delay={i * 0.1} className={i === 1 ? "md:-mt-6" : ""}>
              <motion.div
                data-testid={`testimonial-${i}`}
                whileHover={{ y: -6 }}
                className="relative glass rounded-3xl p-8 h-full flex flex-col"
              >
                <Quote size={40} className="text-jo-accent/25 mb-4" fill="currentColor" />
                <h3 className="text-lg font-semibold text-jo-primary">{t.title}</h3>
                <div className="flex gap-1 mt-2 mb-4">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={16} className="text-jo-highlight" fill="currentColor" />
                  ))}
                </div>
                <p className="text-slate-600 font-light leading-relaxed flex-1">"{t.quote}"</p>
                <div className="mt-6 pt-5 border-t border-jo-primary/10">
                  <div className="font-semibold text-jo-primary text-sm">{t.author}</div>
                  <div className="text-xs text-slate-500">{t.company}</div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
